import {enableMenuNavigation} from "@utils/accessibility/menu";
import { toggleMenu } from "@utils/accessibility/menu";



const setupPuesAccessibility = () => {

    // open menus on click
    document.querySelectorAll(".product-sorting .sort-set .sort-selected").forEach((menu) => {
        if (menu.hasAttribute("data-click-handler-added")) {
            return;
        }
        menu.setAttribute("data-click-handler-added", "true");

        menu.addEventListener("click", ()=>{
            menu.querySelectorAll<HTMLElement>(".sort-selection").forEach((list)=>{
                toggleMenu(list)
            })
        })
    })

    // make them keyboard navigatable
    document.querySelectorAll(".product-sorting .sort-set").forEach((menuContainer) => {
        menuContainer.querySelectorAll<HTMLElement>(".sort-selection").forEach((list)=>{
            enableMenuNavigation(list, menuContainer.querySelector(".sort-selected") as HTMLElement)
        })
    });
}

export {setupPuesAccessibility}
